import React from "react";
import { TextField, Button } from "@mui/material";

import { useState } from "react";

const ForgotPass = ({ onSubmit }) => {
  const [phone, setPhone] = useState("");

  return (
    <>
      <div className="account-content px-4 px-sm-6">
        <p className="font-size-20 font-weight-bold text-center">
            Нууц үг сэргээх
        </p>
        <TextField
          className="mb-3 w-100"
          label={`Утасны дугаар`}
          variant="outlined"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>
      <div className="dialog-footer">
        <Button
          onClick={onSubmit}
          className="bg-primary btn-bordered w-100"
          variant="contained"
          disableElevation
        >
          <span className="mx-2">Үргэлжлүүлэх</span>
        </Button>
      </div>
    </>
  );
};

export default ForgotPass;
